// 2ECOMP: performance-fix v2 — tempo relativo throttled a 60s
// Singleton: UM único setInterval compartilhado por TODOS os DeviceRows
// v2: só registra listener se timestamp != null (device parado)
// Devices em movimento NÃO ficam no pool → handler < 5ms

import {
  useState, useEffect, useCallback, useRef,
} from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/pt-br';

dayjs.extend(relativeTime);
dayjs.locale('pt-br');

const listeners = new Set();
let intervalId = null;

const startInterval = () => {
  if (intervalId) return;
  intervalId = setInterval(() => {
    listeners.forEach((fn) => fn());
  }, 60000);
};

const stopInterval = () => {
  if (listeners.size === 0 && intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

const useRelativeTime = (timestamp, thresholdMinutes = 5) => {
  const [label, setLabel] = useState('');
  const labelRef = useRef('');
  const timestampRef = useRef(timestamp);

  useEffect(() => {
    timestampRef.current = timestamp;
  }, [timestamp]);

  // 2ECOMP: performance-fix v2 — deps vazias, usa refs
  const compute = useCallback(() => {
    const ts = timestampRef.current;
    if (!ts) {
      if (labelRef.current !== '') {
        labelRef.current = '';
        setLabel('');
      }
      return;
    }
    const diffMin = dayjs().diff(dayjs(ts), 'minute');
    const newLabel = diffMin >= thresholdMinutes ? dayjs(ts).fromNow(true) : '';
    if (newLabel !== labelRef.current) {
      labelRef.current = newLabel;
      setLabel(newLabel);
    }
  }, [thresholdMinutes]);

  useEffect(() => {
    // 2ECOMP: performance-fix v2 — timestamp null (em movimento) → sem listener
    if (!timestamp) {
      if (labelRef.current !== '') {
        labelRef.current = '';
        setLabel('');
      }
      return undefined;
    }

    compute();
    listeners.add(compute);
    startInterval();

    return () => {
      listeners.delete(compute);
      stopInterval();
    };
  }, [timestamp, compute]);

  return label;
};

export default useRelativeTime;
